export default __webpack_public_path__ + "static/media/06__o_5.42eadefd.jpg";